export default __webpack_public_path__ + "static/media/KZ.T.13.2472 black.3e3a2d9d.svg";